import React from "react";
import FlashNotice from "./FlashNotice";
import FlashAlert from "./FlashAlert";

interface FlashProps {
  notice?: string;
  alert?: string;
}

const Flash = ({ notice, alert }: FlashProps) => {
  if (!notice && !alert) return null;
  return (
    <div className="absolute w-full top-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-center pt-4">
          {notice && <FlashNotice message={notice} />}
          {alert && <FlashAlert message={alert} />}
        </div>
      </div>
    </div>
  );
};

export default Flash;
